import { createAction } from "redux-act";
import { IFilters } from 'apps/BWW_PLAY_HUB/modules/reducers/filters';

export const setFilter = createAction<Partial<IFilters>>();